import {
  React,
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { PageContext } from "../../App";
import { formatBytes, getFileExtension } from "../Utils";
import ImageViewerView from "../image_viewer/ImageViewerView";
import { HexColorPicker } from "react-colorful";
import { StandardFonts } from "pdf-lib-plus-encrypt";
import WatermarkPositions from "../watermark_pdf/WatermarkPositions";
import { useDropzone } from "react-dropzone";
import { watermarkImageFile } from "../ImageHelper/ImageRenderer";
import { saveFile } from "../Utils";

function WatermarkImageListImagesScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //additional settings
  const [additionalSettings, setAdditionalSettings] = useState({
    watermark_text: "shivapdf.com",
    imageFile: null,
    font: {
      font: StandardFonts.Courier,
      popupShowing: false,
    },
    font_size: 20,
    position: { position: WatermarkPositions.Center, popupShowing: false },
    color: { color: "#000000", popupShowing: false },
    opacity: {
      opacity: 50,
      popupShowing: false,
    },
    rotation: {
      rotation: 0,
      popupShowing: false,
    },
    padding: { x: 0, y: 0 }, //padding in pixels
    on_top: true,
  });
  //is watermarking
  const [isWatermarking, setIsWatermarking] = useState(false);

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //dropped files
  const onDrop = useCallback(
    (selectedFiles) => {
      //check
      if (selectedFiles.length === 0) {
        //return
        return;
      }
      //set files
      setAdditionalSettings({
        ...additionalSettings,
        imageFile: selectedFiles[0],
      });

      // Do something with the files
      console.log("files: ", selectedFiles);
    },
    [additionalSettings],
  );

  const { getInputProps } = useDropzone({
    noDrag: true,
    onDrop,
    accept: {
      "image/jpg": [".jpg"],
      "image/jpeg": [".jpeg"],
      "image/png": [".png"],
      "image/webp": [".webp"],
      "image/bmp": [".bmp"],
    },
    multiple: false,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnails
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //selected file
      const selectedFile = selectedFiles[i];
      //path image file
      const key = String(selectedFile.path);
      //set image
      setFilesInfo((prevDictionary) => ({
        ...prevDictionary,
        [key]: {
          ...filesInfo[key],
          state: AppState.LOADED,
          thumbnail: URL.createObjectURL(selectedFile),
          message: "",
          mimeType: selectedFile.type,
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          watermarked_blob: null,
          watermarked_size: 0,
        },
      }));
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //on change padding
  const onChangePaddingValues = (e) => {
    //set padding
    setAdditionalSettings({
      ...additionalSettings,
      padding: {
        ...additionalSettings.padding,
        x:
          e.target.id === "paddingX"
            ? e.target.value
            : additionalSettings.padding.x,
        y:
          e.target.id === "paddingY"
            ? e.target.value
            : additionalSettings.padding.y,
      },
    });
  };

  //on chnage checkbox values
  const onChangeCheckboxValues = (e) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      on_top: e.target.checked,
    });
  };

  //on change text color
  const onChangeTextColorValues = (color) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      color: { ...additionalSettings.color, color: color },
    });
  };

  //on chnage watermark text
  const onChangeWatermarkText = (e) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      watermark_text: e.target.value,
    });
  };

  //on chnage size text
  const onChangeFontSizeText = (e) => {
    //set
    setAdditionalSettings({
      ...additionalSettings,
      font_size: Math.max(1, e.target.value),
    });
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file:
              String(item.path) in filesInfo
                ? filesInfo[String(item.path)].watermarked_blob === null
                  ? item
                  : filesInfo[String(item.path)].watermarked_blob
                : item,
          });
        }}
      >
        {/* Flex container left image right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="image_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size: {formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "PROCESSED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {`Page: ${index + 1}`}
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          <div
            className="position-absolute justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //check
                  if (String(item.path) in filesInfo === true) {
                    //blob
                    const blob = filesInfo[String(item.path)].watermarked_blob;
                    //save
                    await saveFile(blob, filesInfo[String(item.path)].name);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show image preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Watermark Images"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Watermark Text */}
              <div
                className="ms-4"
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Label */}
                <label
                  htmlFor="watermarkText"
                  className="form-label mt-5 fs-4 text-dark"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Add watermark text to photos"
                >
                  Watermark Text:
                </label>
                <input
                  type="text"
                  className="form-control mt-2"
                  id="watermarkText"
                  value={additionalSettings.watermark_text}
                  placeholder="Type watermark text here..."
                  onChange={onChangeWatermarkText}
                />

                {/* Font */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Font:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing:
                              additionalSettings.font.popupShowing === true
                                ? false
                                : true,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                          rotation: {
                            ...additionalSettings.rotation,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.font.font)}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.font.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {Object.values(StandardFonts).map((item, index) => (
                        <button
                          key={index}
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //show hide color picker
                            //turn other popups off
                            setAdditionalSettings({
                              ...additionalSettings,
                              font: {
                                ...additionalSettings.font,
                                font: item,
                                popupShowing:
                                  additionalSettings.font.popupShowing === true
                                    ? false
                                    : true,
                              },
                              position: {
                                ...additionalSettings.position,
                                popupShowing: false,
                              },
                              color: {
                                ...additionalSettings.color,
                                popupShowing: false,
                              },
                              opacity: {
                                ...additionalSettings.opacity,
                                popupShowing: false,
                              },
                              rotation: {
                                ...additionalSettings.rotation,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {String(item)}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Font Size */}
                <div
                  className="d-flex mt-1 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">
                    Font Size:
                  </label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="fontSize"
                    placeholder="Font size in px (20)"
                    onChange={onChangeFontSizeText}
                    value={additionalSettings.font_size}
                    style={{ width: "calc(100% - 88px)" }}
                  />
                </div>

                {/* Font Color */}
                <div className="d-flex mt-2 my-auto">
                  <div>
                    {/* Label */}
                    <label className="fs-6 me-2 text-secondary py-2">
                      Font Color:
                    </label>
                    {/* Show color value */}
                    <label
                      className={`text-center py-1 px-3 rounded-2 ${
                        additionalSettings.color.color !== "#ffffff"
                          ? "text-white"
                          : "text-dark"
                      }`}
                      style={{
                        backgroundColor: additionalSettings.color.color,
                      }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing:
                              additionalSettings.color.popupShowing === true
                                ? false
                                : true,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                          rotation: {
                            ...additionalSettings.rotation,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {additionalSettings.color.color}
                    </label>
                    {/* Color Picker */}
                    <HexColorPicker
                      className={`my-custom-picker mt-2 ${
                        additionalSettings.color.popupShowing === true
                          ? ""
                          : "d-none"
                      }`}
                      color={additionalSettings.color.color}
                      onChange={onChangeTextColorValues}
                    />
                  </div>
                </div>
              </div>

              {/* Image */}
              <div
                className="ms-4 mt-2"
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Watermark Image */}
                <div className="w-100 mt-4 border-top pt-3">
                  <label className="fs-4">Watermark Image:</label>
                </div>
                {/* Label */}
                <label className="fs-6 mt-2 me-2 text-secondary">Image:</label>
                {/* Select image */}
                <label className="text-primary" style={{ cursor: "pointer" }}>
                  {/* On click open file select menu */}
                  <input {...getInputProps()} />
                  {additionalSettings.imageFile === null
                    ? "Select Image"
                    : additionalSettings.imageFile.name}
                </label>
                {/* Cross button */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className={`bi bi-x-circle ms-2 ${
                    additionalSettings.imageFile === null ? "d-none" : ""
                  }`}
                  viewBox="0 0 16 16"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    //set null
                    setAdditionalSettings({
                      ...additionalSettings,
                      imageFile: null,
                    });
                  }}
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              </div>

              {/* Additional settings */}
              <div
                className="ms-4 "
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Additional settings */}
                <div className="w-100 mt-4 border-top pt-3">
                  <label className="fs-4">Configurations:</label>
                </div>

                {/* Position */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Position:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing:
                              additionalSettings.position.popupShowing === true
                                ? false
                                : true,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                          rotation: {
                            ...additionalSettings.rotation,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.position.position)}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.position.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {Object.values(WatermarkPositions).map((item, index) => (
                        <button
                          key={index}
                          className="dropdown-item"
                          type="button"
                          onClick={(e) => {
                            //show hide color picker
                            //turn other popups off
                            setAdditionalSettings({
                              ...additionalSettings,
                              font: {
                                ...additionalSettings.font,
                                popupShowing: false,
                              },
                              position: {
                                ...additionalSettings.position,
                                position: item,
                                popupShowing:
                                  additionalSettings.position.popupShowing ===
                                  true
                                    ? false
                                    : true,
                              },
                              color: {
                                ...additionalSettings.color,
                                popupShowing: false,
                              },
                              opacity: {
                                ...additionalSettings.opacity,
                                popupShowing: false,
                              },
                              rotation: {
                                ...additionalSettings.rotation,
                                popupShowing: false,
                              },
                            });
                          }}
                        >
                          {String(item)}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Opacity */}
                <div className="d-flex mt-1 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Opacity:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing:
                              additionalSettings.opacity.popupShowing === true
                                ? false
                                : true,
                          },
                          rotation: {
                            ...additionalSettings.rotation,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.opacity.opacity)}%
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.opacity.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {[0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                        (item, index) => (
                          <button
                            key={index}
                            className="dropdown-item"
                            type="button"
                            onClick={(e) => {
                              //show hide color picker
                              //turn other popups off
                              setAdditionalSettings({
                                ...additionalSettings,
                                font: {
                                  ...additionalSettings.font,
                                  popupShowing: false,
                                },
                                position: {
                                  ...additionalSettings.position,
                                  popupShowing: false,
                                },
                                color: {
                                  ...additionalSettings.color,
                                  popupShowing: false,
                                },
                                opacity: {
                                  ...additionalSettings.opacity,
                                  opacity: item,
                                  popupShowing:
                                    additionalSettings.opacity.popupShowing ===
                                    true
                                      ? false
                                      : true,
                                },
                                rotation: {
                                  ...additionalSettings.rotation,
                                  popupShowing: false,
                                },
                              });
                            }}
                          >
                            {String(item)}%
                          </button>
                        ),
                      )}
                    </div>
                  </div>
                </div>

                {/* Rotation */}
                <div className="d-flex mt-1 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Rotation:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setAdditionalSettings({
                          ...additionalSettings,
                          font: {
                            ...additionalSettings.font,
                            popupShowing: false,
                          },
                          position: {
                            ...additionalSettings.position,
                            popupShowing: false,
                          },
                          color: {
                            ...additionalSettings.color,
                            popupShowing: false,
                          },
                          opacity: {
                            ...additionalSettings.opacity,
                            popupShowing: false,
                          },
                          rotation: {
                            ...additionalSettings.rotation,
                            popupShowing:
                              additionalSettings.rotation.popupShowing === true
                                ? false
                                : true,
                          },
                        });
                      }}
                    >
                      {String(additionalSettings.rotation.rotation)}°
                    </label>
                    <div
                      className={`dropdown-menu ${
                        additionalSettings.rotation.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      {[0, 45, 90, 135, 180, 225, 270, 315, 360].map(
                        (item, index) => (
                          <button
                            key={index}
                            className="dropdown-item"
                            type="button"
                            onClick={(e) => {
                              //show hide color picker
                              //turn other popups off
                              setAdditionalSettings({
                                ...additionalSettings,
                                font: {
                                  ...additionalSettings.font,
                                  popupShowing: false,
                                },
                                position: {
                                  ...additionalSettings.position,
                                  popupShowing: false,
                                },
                                color: {
                                  ...additionalSettings.color,
                                  popupShowing: false,
                                },
                                opacity: {
                                  ...additionalSettings.opacity,
                                  popupShowing: false,
                                },
                                rotation: {
                                  ...additionalSettings.rotation,
                                  rotation: item,
                                  popupShowing:
                                    additionalSettings.rotation.popupShowing ===
                                    true
                                      ? false
                                      : true,
                                },
                              });
                            }}
                          >
                            {String(item)}°
                          </button>
                        ),
                      )}
                    </div>
                  </div>
                </div>

                {/* Checkbox onTop */}
                <div className="d-flex mt-1">
                  <label
                    className="form-check-label text-secondary"
                    htmlFor="ontop"
                  >
                    Place on top
                  </label>
                  <input
                    className="ms-3 form-checkbox"
                    type="checkbox"
                    value=""
                    checked={additionalSettings.on_top}
                    id="ontop"
                    onChange={onChangeCheckboxValues}
                  />
                </div>

                {/* Padding */}
                <div className="mt-2">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary my-auto">
                    Padding (x, y) in pixels:
                  </label>
                  <div className="d-flex mt-2 my-auto text-center">
                    {/* padding x */}
                    <div className="d-flex">
                      {/* X input */}
                      <input
                        className="form-control"
                        id="paddingX"
                        value={additionalSettings.padding.x}
                        placeholder="5px"
                        style={{ width: "80px" }}
                        type="number"
                        onChange={onChangePaddingValues}
                      />
                      {/* label , */}
                      <label className="ms-1">,</label>
                      {/* y input */}
                      <input
                        className="form-control ms-1"
                        id="paddingY"
                        value={additionalSettings.padding.y}
                        placeholder="5px"
                        style={{ width: "80px" }}
                        type="number"
                        onChange={onChangePaddingValues}
                      />
                    </div>
                  </div>

                  {/* note label padding */}
                  <label className="fs-6 text-success mt-2">
                    +ve padding x shifts Right and -ve padding x shifts Left
                    <br /> +ve padding y shifts Up and -ve padding y shifts Down
                  </label>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isWatermarking ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //set
                  setIsWatermarking(true);
                  //watermark image
                  //loop
                  for (let i = 0; i < selectedFiles.length; i++) {
                    //selected file
                    const selectedFile = selectedFiles[i];
                    //key
                    const key = String(selectedFile.path);
                    //check
                    if (key in filesInfo === false) {
                      //continue
                      continue;
                    }

                    //watermark image file
                    await watermarkImageFile(
                      selectedFile,
                      {
                        text: additionalSettings.watermark_text,
                        image: additionalSettings.imageFile,
                        font: additionalSettings.font.font,
                        font_size: additionalSettings.font_size,
                        position: additionalSettings.position.position,
                        color: additionalSettings.color.color,
                        opacity: additionalSettings.opacity.opacity,
                        rotation: additionalSettings.rotation.rotation,
                        padding: {
                          x: Number(additionalSettings.padding.x),
                          y: Number(additionalSettings.padding.y),
                        },
                        on_top: additionalSettings.on_top,
                      },
                      (blob) => {
                        //set
                        //set blob
                        setFilesInfo((prevDictionary) => ({
                          ...prevDictionary,
                          [key]: {
                            ...filesInfo[key],
                            state: AppState.PROCESSED,
                            message: `Successfully watermarked image. Click on download button to save.`,
                            watermarked_blob:
                              blob === null ? selectedFile : blob,
                            watermarked_size:
                              blob === null ? selectedFile.size : blob.size,
                          },
                        }));
                      },
                    );
                  }
                  //reset
                  setIsWatermarking(false);
                }}
              >
                Watermark
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WatermarkImageListImagesScreen;
